import { Box, Button, Modal, ThemeOverride } from "@modernatx/ui-kit-react";
import React, { useEffect, useState } from "react";

import { PrescribingInfoModalBlockProps } from "@/types/Block";

import { BlockText } from "./BlockText";

export const PrescribingInfoModal: React.FC<PrescribingInfoModalBlockProps> = ({
  heading,
  body,
  sessionKey,
  buttonText = "Okay"
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    if (!sessionKey || !window.sessionStorage.getItem(sessionKey)) {
      setIsOpen(true);
    }
  }, [sessionKey]);

  const handleClose = () => {
    setIsOpen(false);
    if (typeof window !== "undefined" && sessionKey) {
      window.sessionStorage.setItem(sessionKey, "1");
    }
  };

  return (
    <ThemeOverride theme={{ colorsLight: { backgroundOverlay01: "rgba(37, 38, 39, 0.4)" } }}>
      <Modal isOpen={isOpen} size="sm" aria-label="prescribing-info-modal" onDismiss={handleClose}>
        <Box sx={{ p: [5, 6] }}>
          <Box sx={{ mb: 4 }}>
            <BlockText {...heading} />
          </Box>
          <Box sx={{ mb: 8 }}>
            <BlockText {...body} />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button size="small" onClick={handleClose}>
              <BlockText text={buttonText} />
            </Button>
          </Box>
        </Box>
      </Modal>
    </ThemeOverride>
  );
};
